export const formatAxisMonthLabel = (year: number, monthIndex: number) => {
  const date = new Date(year, monthIndex + 1, 0)
  const label = date.toLocaleDateString('nb-NO', {
    day: 'numeric',
    month: 'long'
  })

  return label.charAt(0).toUpperCase() + label.slice(1)
}

export const formatShortMonthLabel = (year: number, monthIndex: number) => {
  return new Date(year, monthIndex, 1)
    .toLocaleDateString('nb-NO', { month: 'short' })
    .replace('.', '')
    .toLowerCase()
}

export const formatPlannedVsTakenPercent = ({
  samplesTaken,
  samplesPlanned
}: {
  samplesTaken: number
  samplesPlanned: number
}) => {
  if (samplesPlanned === 0) return '0.0'
  return ((samplesTaken / samplesPlanned) * 100).toFixed(1)
}

export const formatCount = (value: number) => value.toLocaleString('nb-NO')

export const formatPercent = (
  value: number,
  options: Intl.NumberFormatOptions = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }
) => `${value.toLocaleString('nb-NO', options)} %`
